module.exports = __webpack_public_path__ + "img/content-banner.fa8aaef5.png";